import * as React from 'react';
import { Link } from 'react-router-dom';
import { AppContext, AppContextType } from '../../AppContextType';
import { Candidate } from '../../Model/Candidate';
import { UriBuilder } from '../../Service/UriBuilder';

export interface GroupProps {
    model: Candidate
}

export class GroupItem extends React.PureComponent<GroupProps> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    public render() {
        const model = this.props.model;
        const department = model.department;
        const className = 'job-center-list-item department-'
            + (department ? department.referenceId : '')
            + (model.highlight ? ' -highlight' : '');
        const uriBuilder = new UriBuilder();
        const departmentBlock = department && this.context.departmentId === ''
            ? <div>in {department.title}</div>
            : null;

        return <Link to={uriBuilder.uriForModel(model)} className={className}>
            <div className="row">
                <div className="col-sm-9 title">{model.title}</div>
                <div className="col-sm-2 col-reference-id">
                    <div className="reference-id">REF {model.referenceId}</div>
                    {departmentBlock}
                </div>
                <div className="col-sm-1">{model.highlight}</div>
            </div>
        </Link>;
    }
}
